import { Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";
import BaseButton from "./BaseButton";


export default class HowToPlayButton extends BaseButton {
  constructor(bounds: ButtonBounds) {
    super("howtoplay", Sounds.click1, false);
    Object.assign(this, bounds);
  }
  handlePress(): void {
    this.EventBus.emit(this.EnumEventBus.setHowToPlayMode, true);
  }
}